<app-instructions-form [instructionTypeName]="instructionTypeName" [instructionsFormArray]="instructionsFormArray" [minDate]="minDate" [maxDate]="maxDate"
					   [preScheduleInstructionTemplate]="preScheduleInstruction" [postScheduleInstructionTemplate]="postScheduleInstruction" [scheduleConfig]="itemConfig.scheduleConfig" (addInstructionClicked)="addInstruction()">
	<!--only need to set the template references above if they are used in app-instructions-form-->
</app-instructions-form>
<ng-template #preScheduleInstruction let-group="instructionFormGroup">
	<!--add any form controls here, typically inside "form-group" classed divs. Public properties/methods of this component are accessible to the template-->
</ng-template>
<ng-template #postScheduleInstruction let-group="instructionFormGroup">
	<div class="form-group" [formGroup]="group">
		<app-select label="Eye" placeholder="choose..." [items]="lubricatedEyes" [saveValue]="true" formControlName="lubricatedEye"></app-select>
	</div>
</ng-template>